import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {USER_TABS} from 'src/constants';
import {STATSIG_GATES} from 'src/contexts/statsig-contex';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {SecondaryTabs, Tab} from '@pb/kit-component-tabs-v2';
import {useGateValue} from '@pb/kit-lib-statsig';

import {ENTITLEMENTS_SUB_TABS} from './constants';

import {entitlementsSubTabTabs} from './entitlements-subtab.module.styl';

type Props = {
    userId: number,
    activeSubTab: string,
};

export const EntitlementsTabBar = ({userId, activeSubTab}: Props) => {
    const navigate = useNavigate();
    const isDatasetEnabled = useGateValue(STATSIG_GATES.DATASET_ENTITLEMENTS);
    const {userTabChange} = useEventTracking();

    const setActiveTab = useCallback((tab: string) => {
        userTabChange({activeTab: tab, previousTab: activeSubTab});
        navigate(
            `/profile/user/${userId}/${USER_TABS.ENTITLEMENTS.name}/${tab}`,
        );
    }, [userId, navigate, activeSubTab, userTabChange]);

    return (
        <SecondaryTabs
            value={activeSubTab}
            onChange={setActiveTab}
            className={entitlementsSubTabTabs}
            style={{width: '100%'}}>
            <Tab
                value={ENTITLEMENTS_SUB_TABS.USER_ENTITLEMENTS.name}
                {...ENTITLEMENTS_SUB_TABS.USER_ENTITLEMENTS}
            />
            <Tab
                value={ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS.name}
                {...ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS}
            />
            {isDatasetEnabled ? (
                <Tab
                    value={ENTITLEMENTS_SUB_TABS.DATASET_ENTITLEMENTS.name}
                    {...ENTITLEMENTS_SUB_TABS.DATASET_ENTITLEMENTS}
                />
            ) : null}
        </SecondaryTabs>
    );
};
